import "./TabsFilter.scss";
import {
  AssessmentButton,
  JobCvList,
  Pagination,
  showToast,
  TemplateSearch,
  TypeSelect,
} from "ui-components";
import "./TabsFilter.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { cvCompleteScan } from "../../../../../../service/CvScanning/CvScanning";
import FileUpload from "../FileUpload/FileUpload";
import CustomModal from "../../../../../../components/CustomModal/CustomModal";
import CreditCoin from "../../../../../../utils/Images/CreditCoin";
import {
  checkTimeDifference,
  convertDate,
  copyToClipboard,
  formatUrl,
  foundUniqueId,
  getTimeDifference,
  handleDownloadDocument,
  removeFromQueryParams,
  scrollWindowTop,
  setInQueryParams,
} from "../../../../../../utils/Common/Constant";
import { sendInvitationApi } from "../../../../../../service/Invite/Invite";
import Content from "./Content";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../../../components/Loader/Loader";
import UpArrowIcon from "../../../../../../utils/Images/UpArrowIcon";
import DownArrowIcon from "../../../../../../utils/Images/DownArrowIcon";
import ComingSoon from "../../../../Common/ComingSoon/ComingSoon";
import UserIcon from "../../../../../../utils/Images/AddSource/UserIcon";
import EmailIcon from "../../../../../../utils/Images/AddSource/EmailIcon";
import LinkedinIconSm from "../../../../../../utils/Images/LinkedinIconSm";
import GithubIcon from "../../../../../../utils/Images/GithubIcon";
import DownloadCVIcon from "../../../../../../utils/Images/DownloadCVIcon";
const TabsFilter = ({
  tabActive,
  jobId,
  handleFilesUploaded,
  fileUploadData,
  setFileProgressList,
  fileProgressList,
  isConfirmScanCvs,
  isAssessmentAvailable,
  selectedSourceType,
  setSelectedSourceType,
  isfilterColumns,
  setIsFilterColumns,
  isDirectionArrow,
  setIsDirectionArrow,
  setSearchCv,
  searchCv,
  setCurrentPage,
  currentPage,
  updateCountFunc,
  searchCvDelay,
  cvListData,
  totalCvListData,
  setPageSize,
  pageSize,
  setLoading,
  loading,
  sourceType,
  cvListFunData,
  loadingCvList,
  hasInProgress,
  isInvited,
  setIsInvited,
  scoreCalculationSideBar,
  setScoreCalculationSideBar,
  setCvStatus,
  cvStatus,
  jobTitle,
  isSourceTypeFilterVisible,
  venderTabId,
  contractDocPopup,
  setContractDocPopup,
  showDocument,
  setShowDocument,
}: any) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [scanningCvIds, setScanningCvIds] = useState<string[]>([]);
  const emailRef = useRef(null);
  const [invitedEmal, setInvitedEmail] = useState<any>({
    email: "",
    firstName: "",
    lastName: "",
  });
  useEffect(() => {
    if (isInvited) {
      const invitedCvDetails = cvListData?.find(
        (item: any) => item?.refId === isInvited,
      );
      setInvitedEmail({
        email: invitedCvDetails?.email,
        firstName: invitedCvDetails?.firstName,
        lastName: invitedCvDetails?.lastName,
      });
    }
  }, [cvListData]);
  const [shouldCVListApiCall, setShouldCVListApiCall] = useState(false);
  // static filterColumns data
  const filterColumns = [
    { label: t("RESUME.SCANNING_OVERALL"), value: "overAll" },
    { label: t("RESUME.SCANNING_EXPERIENCE"), value: "experience" },
    { label: t("GENERAL.SKILLS"), value: "skill" },
    { label: t("RESUME.SCANNING_PROJECTS"), value: "project" },
    { label: t("RESUME.SCANNING_KEYWORDS"), value: "keywords" },
    {
      label: t("RESUME.SCANNING_RELEVANT_PROJECTS"),
      value: "relevantProject",
    },
    {
      label: t("RESUME.SCANNING_UPLOAD_DATE"),
      value: "uploadedDate",
    },
    {
      label: t("RESUME.SCANNING_SCANNED_DATE"),
      value: "scannedDate",
    },
  ];
  const scanStatusOptions = [
    { label: t("RESUME.SCANNING_All"), value: "all" },
    { label: t("GENERAL.NEW"), value: "unscanned" },
    { label: t("RESUME.ASSESSMENT_SCANNED_CVS"), value: "scanned" },
    { label: t("GENERAL.INVITED"), value: "invited" },
  ];
  const isBulkScanning = queryParams.get("bulkScanning") === "true";
  useEffect(() => {
    if (jobId) {
      cvListFunData();
    }
    // updateCountFunc();
  }, [
    isDirectionArrow,
    isfilterColumns,
    searchCvDelay,
    selectedSourceType,
    isConfirmScanCvs,
    currentPage,
    tabActive,
    cvStatus,
    venderTabId,
    jobId,
  ]);
  useEffect(() => {
    if (hasInProgress) {
      const interval = setInterval(() => {
        if (shouldCVListApiCall) {
          // pass the page no. 1 when auto refresh
          cvListFunData(1);
        }
      }, 5000);
      return () => clearInterval(interval); // Cleanup on unmount
    } else {
      if (totalCvListData <= 0 && isBulkScanning) {
        setCvStatus("scanned");
        removeFromQueryParams(queryParams, "bulkScanning", navigate);
      }
    }
  }, [shouldCVListApiCall, hasInProgress]);
  // handle bulk scan
  const handleTopScanCV = async (
    jobId: string,
    totalCount: any,
    cvId?: string,
  ) => {
    setInQueryParams(queryParams, "bulkScanning", true, navigate);
    setLoading(true);
    const scancvRes = await cvCompleteScan(jobId, totalCount, cvId);
    if (scancvRes?.status === 200) {
      showToast(
        `${scancvRes?.data?.cvScan} ${t("RESUME.SCANNING_10_CVS_SCANNED_SUCCESSFULLY")}`,
        "success",
      );
      setShouldCVListApiCall(true);
      setLoading(false);
      cvListFunData();
      updateCountFunc();
      setCurrentPage(1);
    } else {
      setLoading(false);
      removeFromQueryParams(queryParams, "bulkScanning", navigate);
    }
  };
  // handle single scan
  const handleScanCV = async (
    jobId: string,
    totalCount: any,
    cvId?: string,
  ) => {
    if (!cvId) return;
    setScanningCvIds((prev) => [...prev, cvId]); // Add cvId to the list
    try {
      const scancvRes = await cvCompleteScan(jobId, totalCount, cvId);
      if (scancvRes?.status === 200) {
        showToast(scancvRes?.customMessage, "success");
        setShouldCVListApiCall(true);
        updateCountFunc();
        cvListFunData();
      }
    } finally {
      setScanningCvIds((prev) => prev.filter((id) => id !== cvId)); // Remove cvId after completion
    }
  };
  // handle invited email functionality
  const handleInvitedEmail = async (assessId: string) => {
    setLoading(true);
    const data = {
      assessmentId: assessId,
      emailId: invitedEmal?.email,
      firstName: invitedEmal?.firstName,
      lastName: invitedEmal?.lastName,
    };
    const sendInvitationRes = await sendInvitationApi(data);
    if (sendInvitationRes?.data?.status === 200) {
      showToast(sendInvitationRes?.data?.customMessage, "success");
      setLoading(false);
      setIsInvited(null);
      updateCountFunc();
      cvListFunData();
      removeFromQueryParams(queryParams, "cvId", navigate);
    } else {
      setIsInvited(null);
      setLoading(false);
      removeFromQueryParams(queryParams, "cvId", navigate);
    }
  };
  // change the order desc/asc
  const handleDirectionArrow = () => {
    if (isDirectionArrow === "desc") {
      setIsDirectionArrow("asc");
      setCurrentPage(1);
    } else {
      setIsDirectionArrow("desc");
      setCurrentPage(1);
    }
  };
  return (
    <div className="selfSection">
      <div className="filters">
        <TemplateSearch
          onChange={(e) => {
            setSearchCv(e);
            setCurrentPage(1);
          }}
          placeholder={t("RESUME.SCANNING_SEARCH_CVS")}
          value={searchCv}
          iconName="searchList"
        />
        <div className="sourceTypeFilter row">
          {isSourceTypeFilterVisible && (
            <div className="source col-md-4 ">
              <span>{t("RESUME.SOURCES")}</span>
              <TypeSelect
                options={sourceType}
                loadingText=""
                value={selectedSourceType}
                onChange={(value: any) => {
                  setSelectedSourceType(value);
                  setCurrentPage(1);
                }}
                iconName="icon"
              />
            </div>
          )}
          <div className="source col-md-4">
            <span>{t("GENERAL.STATUS")}</span>
            <TypeSelect
              options={scanStatusOptions}
              loadingText=""
              value={cvStatus}
              onChange={(value: any) => {
                setCvStatus(value);
                setCurrentPage(1);
              }}
              iconName="icon"
            />
          </div>
          <div className="filter col-md-4">
            {cvStatus === "scanned" && (
              <div className="filterCoulmn">
                <span>Sort By</span>
                <TypeSelect
                  options={filterColumns}
                  loadingText=" "
                  value={isfilterColumns}
                  onChange={(value: any) => {
                    setIsFilterColumns(value);
                    setIsDirectionArrow("desc");
                    setCurrentPage(1);
                  }}
                />
                <h6
                  onClick={() => handleDirectionArrow()}
                  className="DownUpArrow"
                >
                  {isDirectionArrow === "asc" ? (
                    <UpArrowIcon />
                  ) : isDirectionArrow === "desc" ? (
                    <DownArrowIcon />
                  ) : (
                    <DownArrowIcon />
                  )}
                </h6>
              </div>
            )}
            {cvStatus === "unscanned" && (
              <>
                <span>{t("RESUME.SCANNING_UPLOAD_DATE")}</span>
                <h6
                  onClick={() => handleDirectionArrow()}
                  className="DownUpArrow"
                >
                  {isDirectionArrow === "asc" ? (
                    <UpArrowIcon />
                  ) : isDirectionArrow === "desc" ? (
                    <DownArrowIcon />
                  ) : (
                    <DownArrowIcon />
                  )}
                </h6>
              </>
            )}
            {cvStatus === "unscanned" && (
              <div>
                <div className="scanTopCvs">
                  <AssessmentButton
                    disabled={
                      loading ||
                      cvListData.some(
                        (item: any) => item.scanStatus === "inprogress",
                      )
                    }
                    onClick={() =>
                      handleTopScanCV(
                        jobId,
                        totalCvListData > 10 ? 10 : totalCvListData,
                        "",
                      )
                    }
                  >
                    {cvListData.some(
                      (item: any) => item.scanStatus === "inprogress",
                    ) ? (
                      <div className="scanningCVsBtn">
                        {t("RESUME.SCANNING_SCANNING_CVS")}
                        <Loader />
                      </div>
                    ) : loading ? (
                      <div className="scanJobLoader">
                        <span>{t("RESUME.SCANNING_SCANNING_CVS")}</span>
                        <Loader />
                      </div>
                    ) : (
                      `${t("RESUME.ASSESSMENT_SCAN_TOP_CVS")} ${totalCvListData > 10 ? 10 : totalCvListData} ${t("RESUME.SCANNING_CVS")}`
                    )}
                  </AssessmentButton>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="dividerLine" />
      </div>
      <div>
        {loadingCvList ? (
          <JobCvList />
        ) : cvListData?.length > 0 ||
          searchCv.length ||
          selectedSourceType !== "All" ? (
          <>
            <div className="scannedUnscannedCvs">
              <span>
                {t("RESUME.ASSESSMENT_TOTAL_CVS")} : {totalCvListData}
              </span>
            </div>
            {cvListData?.length ? (
              <>
                <div className="minHeight60">
                  {cvListData?.map((item: any, ind: number) => (
                    <div
                      key={ind}
                      className={`existingJDList mb-3 ${(item?.scanStatus == "unscanned" || item?.scanStatus == "inprogress") && "unscannedListSec"}`}
                    >
                      <div className="jdListUnscanned">
                        <div className="userProfileNameSec">
                          {item?.profilePic ? (
                            <div className="cvProfile">
                              <img src={item?.profilePic} />
                            </div>
                          ) : (
                            <div className="profileImage">
                              <div className="svgBorder">
                                <UserIcon />
                              </div>
                            </div>
                          )}
                          <div className="nameLocation">
                            <div className="nameSurname">
                              <h5>{`${item?.firstName || item?.lastName ? `${item?.firstName ?? ""} ${item?.lastName ?? ""}` : "-"}`}</h5>
                              <div className="emailVector">
                                <p
                                  onClick={() =>
                                    copyToClipboard(
                                      emailRef,
                                      item?.email,
                                      t("RESUME.EMAIL_COPIED"),
                                    )
                                  }
                                  ref={emailRef}
                                >
                                  <span className="emailSvg">
                                    <EmailIcon />
                                  </span>
                                  {item?.email}
                                </p>
                                <p className="source">
                                  {t("RESUME.SCANNING_SOURCE")} :{" "}
                                  <span className="sourceName">
                                    {item?.source}
                                  </span>
                                </p>
                                {item?.cvUrl && (
                                  <p className="source">
                                    {t("RESUME.CV")} :{" "}
                                    <div
                                      title={t("RESUME.DOWNLOAD_CV")}
                                      className="downloadCVIcon"
                                      onClick={() =>
                                        handleDownloadDocument(item?.cvUrl)
                                      }
                                    >
                                      <DownloadCVIcon />
                                    </div>
                                  </p>
                                )}
                                {(item?.githubUrl || item?.linkedInUrl) && (
                                  <p className="source">
                                    {t("RESUME.SOCIAL")} :{" "}
                                    <div className="downloadCVBtn">
                                      <div>
                                        <div className="socialDetails">
                                          {item?.linkedInUrl && (
                                            <span>
                                              <a
                                                href={formatUrl(
                                                  item.linkedInUrl,
                                                )}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                <LinkedinIconSm />
                                              </a>
                                            </span>
                                          )}
                                          {item?.githubUrl && (
                                            <span>
                                              <a
                                                href={formatUrl(item.githubUrl)}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                <GithubIcon />
                                              </a>
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="dateMenuSec">
                              <div className="dateLocation">
                                <span>
                                  {(() => {
                                    const dateToCheck =
                                      item?.matchedDate || item?.createdAt;
                                    const isMoreThan24Hours =
                                      checkTimeDifference(dateToCheck);

                                    return isMoreThan24Hours
                                      ? item?.matchedDate
                                        ? convertDate(
                                            item?.matchedDate,
                                            false,
                                            true,
                                          )
                                        : convertDate(
                                            item?.createdAt,
                                            false,
                                            true,
                                          )
                                      : getTimeDifference(
                                          dateToCheck,
                                          t("GENERAL.MIN(S)"),
                                          t("GENERAL.HOUR(S)"),
                                          t("GENERAL.DAY(S)"),
                                          t("GENERAL.MONTH(S)"),
                                          t("GENERAL.YEAR(S)"),
                                          t("GENERAL.AGO"),
                                          t("GENERAL.JUST_NOW"),
                                        );
                                  })()}
                                </span>
                                {item?.city ||
                                  (item?.country && (
                                    <p className="text-end">
                                      {[item?.city, item?.country]
                                        .filter(Boolean)
                                        .join(", ") || ""}
                                    </p>
                                  ))}
                                {item?.jobContractsId &&
                                  item?.contractStatus == "Active" && (
                                    <div
                                      className="contractCreated"
                                      onClick={() =>
                                        navigate(
                                          `/${currentLanguage}/contractDetails/${item?.jobContractsId}`,
                                        )
                                      }
                                    >
                                      {t("CONTRACT.CONTRACT_STARTED")}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <Content
                          item={item}
                          handleScanCV={handleScanCV}
                          isAssessmentAvailable={isAssessmentAvailable}
                          setInvitedEmail={setInvitedEmail}
                          setIsInvited={setIsInvited}
                          jobId={jobId}
                          scanningCvIds={scanningCvIds}
                          tabActive={tabActive}
                          cvListFunData={cvListFunData}
                          scoreCalculationSideBar={scoreCalculationSideBar}
                          setScoreCalculationSideBar={
                            setScoreCalculationSideBar
                          }
                          loading={loading}
                          jobTitle={jobTitle}
                          setContractDocPopup={setContractDocPopup}
                          contractDocPopup={contractDocPopup}
                          showDocument={showDocument}
                          setShowDocument={setShowDocument}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                {totalCvListData > pageSize && (
                  <div className="row">
                    <div className="col-md-12">
                      <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        totalCount={
                          totalCvListData > pageSize ? totalCvListData : 0
                        }
                        pageSize={pageSize}
                        onPageChange={(page: number) => {
                          scrollWindowTop();
                          setCurrentPage(page);
                        }}
                        ofLabel={t("GENERAL.OF")}
                        resultLabel={t("GENERAL.RESULTS")}
                        setPageSize={setPageSize}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <ComingSoon text={t("RESUME.ASSESSMENT_NO_CVS_FOUND")} />
            )}
          </>
        ) : cvStatus === "unscanned" ? (
          <div className="scanExistingAndFile">
            <FileUpload
              onFilesUploaded={handleFilesUploaded}
              fileUploadData={fileUploadData}
              setFileProgressList={setFileProgressList}
              fileProgressList={fileProgressList}
            />
          </div>
        ) : (
          <>
            <ComingSoon text={t("RESUME.ASSESSMENT_NO_CVS_FOUND")} />
          </>
        )}
        <CustomModal
          show={isInvited}
          isCrossBtn={true}
          isHeaderVisible={false}
          handleClose={() => {
            setIsInvited(null);
            removeFromQueryParams(queryParams, "cvId", navigate);
          }}
          className=""
          size="lg"
          fullscreen="md-down"
          isFooterVisible={false}
        >
          <div className="invitedEmal ">
            <div className="invitedTitle">
              <h3
                className={
                  isAssessmentAvailable?.length ? "haveData" : "haveNotData"
                }
              >
                {isAssessmentAvailable?.length
                  ? t("RESUME.ASSESSMENT_INVITE_APPLICANT_FOR")
                  : t(
                      "RESUME.ASSESSMENT_CREATE_ASSESSMENT_TO_INVITE_AN_APPLICANT",
                    )}
              </h3>
            </div>
            {isAssessmentAvailable?.length ? (
              <>
                <span className="titleName">
                  {isAssessmentAvailable[0]?.title}
                </span>
                <div className="durationQuestions">
                  <p>
                    {t("RESUME.ASSESSMENT_DURATION")} :
                    <span>{isAssessmentAvailable[0]?.totalTime} Mins</span>
                  </p>
                  <div className="divider"></div>
                  <p>
                    {t("GENERAL.NUMBER_OF_QUESTION")} :
                    <span>{isAssessmentAvailable[0]?.totalQuestions}</span>
                  </p>
                </div>
                <div className="horizontalLine w-25 mt-5"></div>
                <div className="nameEmail mt-5 mb-5">
                  <div className="firstAndLastName">
                    <UserIcon />
                    <h5>
                      {invitedEmal?.firstName || invitedEmal?.lastName
                        ? `${invitedEmal?.firstName || ""} ${invitedEmal?.lastName || ""}`.trim()
                        : "-"}
                    </h5>
                  </div>
                  <div className="email">
                    <div>
                      <EmailIcon />
                    </div>
                    <div>
                      <h5>{invitedEmal?.email ? invitedEmal?.email : "-"}</h5>
                    </div>
                  </div>
                </div>
                <div className="creditPayBtn">
                  <div className="creditCoin">
                    <CreditCoin width={25} height={25} />
                    <span>
                      {isAssessmentAvailable[0]?.credits
                        ? isAssessmentAvailable[0]?.credits
                        : 0}
                    </span>
                  </div>
                  <AssessmentButton
                    disabled={loading}
                    onClick={() =>
                      handleInvitedEmail(isAssessmentAvailable[0]?.assessmentId)
                    }
                    className="whiteBtn"
                  >
                    {loading ? (
                      <div className="scanJobLoader">
                        <p>{t("GENERAL.LOADING")}</p>
                        <Loader />
                      </div>
                    ) : (
                      t("RESUME.ASSESSMENT_PAY_AND_INVITE")
                    )}
                  </AssessmentButton>
                </div>
              </>
            ) : (
              <div className="assessNotAvailable">
                <AssessmentButton
                  onClick={() => {
                    navigate(
                      `/${currentLanguage}/assessment/build/${foundUniqueId()}?jobId=${jobId}`,
                    );
                  }}
                >
                  {t("CREATE_ASSESSMENT.TITLE")}
                </AssessmentButton>
              </div>
            )}
          </div>
        </CustomModal>
      </div>
    </div>
  );
};

export default TabsFilter;
